import { render, staticRenderFns } from "./SoCourseHtml.vue?vue&type=template&id=901b4d4e&"
import script from "./SoCourseHtml.vue?vue&type=script&lang=js&"
export * from "./SoCourseHtml.vue?vue&type=script&lang=js&"
import style0 from "./SoCourseHtml.vue?vue&type=style&index=0&id=901b4d4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports